import { Box, Text } from '@factorialco/deprecated-design-system'
import { Switch } from '@factorialco/f0-react/dist/experimental'

interface Props {
  onChange: () => void
  checked: boolean
  id: string
  title: string
  disabled?: boolean
}

const SwitchButton = ({ onChange, checked, id, title, disabled }: Props) => {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      cursor="pointer"
      onClick={disabled ? undefined : onChange}
    >
      <Text size="200" className="text-f1-foreground">
        {title}
      </Text>
      <Switch id={id} checked={checked} disabled={disabled} />
    </Box>
  )
}

export default SwitchButton
